import React, { useState, useEffect } from "react";
import {
    Accordion,
    AccordionSummary,
    Typography,
    makeStyles,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { DataGrid } from "@material-ui/data-grid";

// Custom styles using Material-UI's makeStyles hook
const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 500,
    },
    accordion: {
        width: "fit-content",
        minWidth: "100%",
        marginTop: "10px",
        marginBottom: "10px",
        borderRadius: "5px",
        padding: "5px",
        "&::before": {
            height: "0", // Set height to 0 to avoid the pseudo separator provided by MUI for Accordion
        },
    },
    disabledRow: {
        color: "grey",
    }
}));

// Main component definition
const DataGridComponent = (props) => {
    const classes = useStyles(); // Apply custom styles
    const {
        INWARDING_RECORD_ARRAY, // Array of inwarding records to be displayed in the DataGrid
        COLUMNS, // Columns configuration for the DataGrid
        ORDER_ID, // Order ID to be displayed in the Accordion header
        PAGE_SIZE, // Number of rows per page in the DataGrid
        HANDLE_SELECTED_INWARDING_CHANGE, // Function to handle selection changes in the DataGrid
        VENDOR_NAME, // Vendor Name to be dispalyed in the Accordion header
    } = props;
    const [selectedRows, setSelectedRows] = useState([]); // State to keep track of selected rows' IDs
    const [selectedRowsData, setSelectedRowsData] = useState([]); // State to keep track of selected rows' data

    // Function to handle selection change in the DataGrid
    const handleSelectionChange = (newSelection) => {
        props.setLoading(true);
        try {
            let selectedInwardingArr = [...INWARDING_RECORD_ARRAY];

            for (let el of selectedInwardingArr) {
                if (newSelection.includes(el.id)) {
                    el.isChecked = true;
                } else {
                    el.isChecked = false;
                }
            }
            HANDLE_SELECTED_INWARDING_CHANGE(selectedInwardingArr); // Update the parent component with the selected data
        } catch (error) {
            console.error("Error -> ", error);
        }
        props.setLoading(false);
    };

    // Function to check if row is selectable
    const checkIfRowIsSelectable = (params) => {
        try {
            return !params.row.isPaymentRaised;
        } catch (error) {
            console.error("Error -> ", error);
        }
    };

    return (
        <Accordion className={classes.accordion} defaultExpanded={true}>
            <AccordionSummary
                className="iconposition"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
            >
                <Typography className={classes.heading}>
                    <b>{ORDER_ID}</b> | {VENDOR_NAME}
                </Typography>
            </AccordionSummary>
            <div style={{ width: "100%" }}>
                <DataGrid
                    rows={INWARDING_RECORD_ARRAY} // Rows to display in the DataGrid
                    columns={COLUMNS} // Columns configuration for the DataGrid
                    pageSize={PAGE_SIZE} // Number of rows per page
                    checkboxSelection // Enable checkboxes for selection
                    disableSelectionOnClick // Disable selection on row click
                    disableColumnMenu={true}
                    hideFooterRowCount={false}
                    hideFooterSelectedRowCount={false}
                    getRowClassName={(params) => params.row.isPaymentRaised === true ? `${classes.disabledRow}` : ""}
                    // isRowSelectable={(params) => !params.row.isPaymentRaised}
                    isRowSelectable={(params) => checkIfRowIsSelectable(params)} // Disable checkboxes if payment is raised previously
                    autoHeight={true} // Automatically adjust the height of the DataGrid
                    autoPageSize={true} // Automatically adjust the page size
                    onSelectionModelChange={handleSelectionChange} // Handle selection change
                />
            </div>
        </Accordion>
    );
};

export default connect(null, { setLoading, setSnackInfo })(DataGridComponent);